module.exports = __webpack_public_path__ + "img/error-token.4e660a8e.svg";